import { Link } from "@chakra-ui/react";
import { useLanguage } from "contexts/LocalizationContext";
import NextLink from "next/link";
import { usePathname } from "next/navigation";
import { useMobileMenuStore } from "stores/MobileMenuStore";
import { useLinkRelValue } from "hooks";
import { getActiveLink, handleTrackingEvents, setLinkStyles } from "../Header.utils";
import type { HeaderLink as HeaderLinkType } from "../types";
import { getLinkSource } from "../../globalComponents.utils";

export const HeaderLink = ({
  headerLinkName,
  headerLink,
  headerLinkHideLinkForLanguages,
  headerLinkTrackingEvent,
}: HeaderLinkType) => {
  const pathName = usePathname();
  const language = useLanguage();
  const linkSource = getLinkSource(headerLink);
  const relValue = useLinkRelValue(linkSource);
  const { isOpen: isMobileMenuOpen, close: closeMobileMenu } = useMobileMenuStore();
  const { isActiveLink } = getActiveLink(linkSource, pathName);

  if (headerLinkHideLinkForLanguages && headerLinkHideLinkForLanguages.includes(language)) return null;

  const handleOnClick = () => {
    handleTrackingEvents(headerLinkTrackingEvent);
    if (isMobileMenuOpen) return closeMobileMenu();
    return undefined;
  };

  return (
    <Link
      role="menuitem"
      data-text={headerLinkName}
      onClick={handleOnClick}
      sx={setLinkStyles(isActiveLink, "singleLink")}
      as={NextLink}
      href={linkSource}
      rel={relValue}
      display="inline-block"
      rounded="sm"
    >
      {headerLinkName}
    </Link>
  );
};
